import {
  TRAIL_SUMMARY_REQ,
  TRAIL_SUMMARY_REQ_SUCCESS,
  TRAIL_SUMMARY_REQ_ERROR,
  TRAIL_SUMMARY_REQ_RESET,
  SYSTEM_TRAIL_SUMMARY_REQ,
  SYSTEM_TRAIL_SUMMARY_REQ_RESET,
  ACTIVE_TRAIL_SUMMARY_REQ,
  ACTIVE_TRAIL_SUMMARY_REQ_SUCCESS,
  ACTIVE_TRAIL_SUMMARY_REQ_ERROR,
  PRIVILEGED_TRAIL_SUMMARY_REQ,
  PRIVILEGED_TRAIL_SUMMARY_REQ_SUCCESS,
  PRIVILEGED_TRAIL_SUMMARY_REQ_ERROR,
  MITIGATED_TRAIL_SUMMARY_REQ,
  MITIGATED_TRAIL_SUMMARY_REQ_SUCCESS,
  MITIGATED_TRAIL_SUMMARY_REQ_ERROR,
  VM_VIEW_PREFERENCES_REQ,
  SAVE_VM_VIEW_PREFERENCES
} from './trailsinfo.type'
import ApiRest from '@/api/api-rest'
import { getDateRangeChoice } from '@/utilities/datetime.helper'

const state = {
  trailSummaryStatus: '',
  trailSummary: {},
  activeTrailSummaryStatus: '',
  activeTrailSummary: {},
  privilegedTrailSummaryStatus: '',
  privilegedTrailSummary: {},
  mitigatedTrailSummaryStatus: '',
  mitigatedTrailSummary: {},
  vmPreferences: {}
}

const getters = {
  trailSummaryStatus: state => state.trailSummaryStatus,
  trailSummary: state => state.trailSummary,
  activeTrailSummaryStatus: state => state.activeTrailSummaryStatus,
  activeTrailSummary: state => state.activeTrailSummary,
  privilegedTrailSummaryStatus: state => state.privilegedTrailSummaryStatus,
  privilegedTrailSummary: state => state.privilegedTrailSummary,
  mitigatedTrailSummaryStatus: state => state.mitigatedTrailSummaryStatus,
  mitigatedTrailSummary: state => state.mitigatedTrailSummary,
  vmPreferences: state => state.vmPreferences
}

// Best Practice - updates state
const mutations = {
  [TRAIL_SUMMARY_REQ]: state => {
    state.trailSummaryStatus = 'inprogress'
  },
  [TRAIL_SUMMARY_REQ_SUCCESS]: (state, summary) => {
    state.trailSummaryStatus = 'saved'
    state.trailSummary = summary
  },
  [TRAIL_SUMMARY_REQ_ERROR]: state => {
    state.trailSummaryStatus = 'failed'
  },
  [TRAIL_SUMMARY_REQ_RESET]: state => {
    state.trailSummaryStatus = ''
  },
  [ACTIVE_TRAIL_SUMMARY_REQ]: state => {
    state.activeTrailSummaryStatus = 'inprogress'
  },
  [ACTIVE_TRAIL_SUMMARY_REQ_SUCCESS]: (state, summary) => {
    state.activeTrailSummaryStatus = 'saved'
    state.activeTrailSummary = summary
    state.activeTrailSummary.summaryInfo = [
      {
        label: 'High Risk',
        key: 'high',
        count: summary.numTrailsHigh || 0
      },
      {
        label: 'Medium Risk',
        key: 'medium',
        count: summary.numTrailsMed || 0
      },
      {
        label: 'Low Risk',
        key: 'low',
        count: summary.numTrailsLow || 0
      }
    ]
  },
  [ACTIVE_TRAIL_SUMMARY_REQ_ERROR]: state => {
    state.activeTrailSummaryStatus = 'failed'
  },
  [PRIVILEGED_TRAIL_SUMMARY_REQ]: state => {
    state.privilegedTrailSummaryStatus = 'inprogress'
  },
  [PRIVILEGED_TRAIL_SUMMARY_REQ_SUCCESS]: (state, summary) => {
    state.privilegedTrailSummaryStatus = 'saved'
    state.privilegedTrailSummary = summary
  },
  [PRIVILEGED_TRAIL_SUMMARY_REQ_ERROR]: state => {
    state.privilegedTrailSummaryStatus = 'failed'
  },
  [MITIGATED_TRAIL_SUMMARY_REQ]: state => {
    state.mitigatedTrailSummaryStatus = 'inprogress'
  },
  [MITIGATED_TRAIL_SUMMARY_REQ_SUCCESS]: (state, summary) => {
    state.mitigatedTrailSummaryStatus = 'saved'
    state.mitigatedTrailSummary = summary
  },
  [MITIGATED_TRAIL_SUMMARY_REQ_ERROR]: state => {
    state.mitigatedTrailSummaryStatus = 'failed'
  },
  [SYSTEM_TRAIL_SUMMARY_REQ_RESET]: (state, trailState) => {
    switch (trailState) {
      case 'privileged':
        state.privilegedTrailSummaryStatus = ''
        state.privilegedTrailSummary = {}
        break
      case 'mitigated':
        state.mitigatedTrailSummaryStatus = ''
        state.mitigatedTrailSummary = {}
        break
      default:
        state.activeTrailSummaryStatus = ''
        state.activeTrailSummary = {}
    }
  },
  [VM_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.vmPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [VM_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {  
          let currUserVMPrefs = data.find(pref => {
            return pref.tbl_id === 1 && pref.user_id === uid
          })
          context.commit(VM_VIEW_PREFERENCES_REQ, currUserVMPrefs.prefered_cols)
          resolve(data)
        })
    })
  },

  [SAVE_VM_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [TRAIL_SUMMARY_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_SUMMARY_REQ)
      ApiRest()
        .get('/agents/summaryinfo')
        // .get('static/json/summaryinfo.json')
        .then(({ data }) => {
          function fillTicks (keyColorPair) {
            let trailTicks = []
            let trailTickColors = []

            keyColorPair.forEach((keyval, idx) => {
              trailTicks.length += keyColorPair[idx].count
            })
            trailTicks.fill(1)

            trailTickColors.length = trailTicks.length

            trailTickColors.fill(keyColorPair[0].color, 0, keyColorPair[0].count)

            trailTickColors.fill(
              keyColorPair[1].color,
              keyColorPair[0].count,
              keyColorPair[0].count + keyColorPair[1].count
            )

            trailTickColors.fill(keyColorPair[2].color, keyColorPair[0].count + keyColorPair[1].count)

            return {
              centerDonutTitle: [trailTicks.length, 'Total'],
              datasets: [
                {
                  backgroundColor: trailTickColors,
                  data: trailTicks
                }
              ]
            }
          }

          data.systemSummary = {
            trails: {
              summaryInfo: [
                {
                  label: 'High Risk',
                  key: 'high',
                  count: data.numActiveTrailsHigh || 0
                },
                {
                  label: 'Medium Risk',
                  key: 'medium',
                  count: data.numActiveTrailsMid || 0
                },
                {
                  label: 'Low Risk',
                  key: 'low',
                  count: data.numActiveTrailsLow || 0
                }
              ],
              data: fillTicks([
                {
                  key: 'high',
                  count: data.numActiveTrailsHigh || 0,
                  color: 'rgba(242, 58, 92, 1)'
                },
                {
                  key: 'medium',
                  count: data.numActiveTrailsMid || 0,
                  color: 'rgba(254, 190, 201, 1)'
                },
                {
                  key: 'low',
                  count: data.numActiveTrailsLow || 0,
                  color: 'rgba(246, 228, 228, 1)'
                }
              ]),
              chartOption: {
                plugins: {
                  'donuthole-chart-label-plugin': {
                    style: {
                      circleFillColor: 'white',
                      textfillColor: '#2e3344',
                      textBaseline: 'middle',
                      textAlign: 'center'
                    }
                  }
                }
              }
            },
            agents: {
              summaryInfo: [
                {
                  label: 'At Risk',
                  key: 'online_compromised',
                  count: data.numAgentsOnlineNonzero || 0
                },
                {
                  label: 'Online',
                  key: 'online',
                  count: data.numAgentsOnlineZero || 0
                },
                {
                  label: 'Offline',
                  key: 'offline',
                  count: data.numAgentsOffline || 0
                }
              ],
              data: fillTicks([
                {
                  key: 'onlineZero',
                  count: data.numAgentsOnlineZero || 0,
                  color: 'rgb(0, 112, 249)'
                },
                {
                  key: 'onlineNonZero',
                  count: data.numAgentsOnlineNonzero || 0,
                  color: 'rgba(242, 58, 92, 1)'
                },
                {
                  key: 'offline',
                  count: data.numAgentsOffline || 0,
                  color: 'rgb(206, 206, 206)'
                }
              ]),
              chartOption: {
                plugins: {
                  'donuthole-chart-label-plugin': {
                    style: {
                      circleFillColor: 'white',
                      textfillColor: '#2e3344',
                      textBaseline: 'middle',
                      textAlign: 'center'
                    }
                  }
                }
              }
            }
          }

          context.commit(TRAIL_SUMMARY_REQ_SUCCESS, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_SUMMARY_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAIL_SUMMARY_REQ_SUCCESS] (context, summary) {
    context.commit(TRAIL_SUMMARY_REQ_SUCCESS, summary)
  },
  [TRAIL_SUMMARY_REQ_RESET] (context, summary) {
    context.commit(TRAIL_SUMMARY_REQ_RESET, summary)
  },
  [SYSTEM_TRAIL_SUMMARY_REQ] (context, trailState) {
    // let lastXHours = getDateRangeChoice(context.rootState.daterangePref.dashboardProgressionDateRangeUserSetting)
    let lastXHours = getDateRangeChoice('PAST_1_MONTH')
    let apiRequest = ACTIVE_TRAIL_SUMMARY_REQ
    let apiSuccess = ACTIVE_TRAIL_SUMMARY_REQ_SUCCESS
    let requestUrl = '/trails'
    switch (trailState) {
      case 'privileged':
        apiRequest = PRIVILEGED_TRAIL_SUMMARY_REQ
        apiSuccess = PRIVILEGED_TRAIL_SUMMARY_REQ_SUCCESS
        requestUrl = `${requestUrl}/privilegedsummaryinfo/${lastXHours.hours}`
        break
      case 'mitigated':
        apiRequest = MITIGATED_TRAIL_SUMMARY_REQ
        apiSuccess = MITIGATED_TRAIL_SUMMARY_REQ_SUCCESS
        requestUrl = `${requestUrl}/mitigatedsummaryinfo/${lastXHours.hours}`
        break
      default:
        requestUrl = `${requestUrl}/activesummaryinfo/${lastXHours.hours}`
        break
    }
    return new Promise((resolve, reject) => {
      context.commit(apiRequest)
      ApiRest()
        .get(requestUrl)
        .then(({ data }) => {
          context.commit(apiSuccess, data)
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [SYSTEM_TRAIL_SUMMARY_REQ_RESET] (context, trailState) {
    context.commit(SYSTEM_TRAIL_SUMMARY_REQ_RESET, trailState)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/trailsummary.module.js